export const sessionConstants = {
  SESSION_ACCOUNT: 'SESSION_ACCOUNT',
  SESSION_USER: 'SESSION_USER',
  SESSION_CORE: 'SESSION_CORE',
  END_SESSION: 'END_SESSION'
};
